export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7917.694076e8.jpg";